module.exports = __webpack_public_path__ + "img/clicksFlow.145ea032.svg";